import { render, staticRenderFns } from "./formManage.vue?vue&type=template&id=3b3095da&scoped=true&"
import script from "./formManage.vue?vue&type=script&lang=js&"
export * from "./formManage.vue?vue&type=script&lang=js&"
import style0 from "./formManage.vue?vue&type=style&index=0&id=3b3095da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3095da",
  null
  
)

export default component.exports